import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private readonly refreshSubject = new Subject<void>();
  readonly refresh$ = this.refreshSubject.asObservable();

  constructor(private api: ApiService) {}

  requestRefresh(): void {
    this.refreshSubject.next();
  }

  /**
   * Lấy thông tin user hiện tại
   */
  getCurrentUser(): Observable<any> {
    return this.api.get('user/info').pipe(
      catchError(() => this.api.get('user/info'))
    );
  }

  getAvatar(): Observable<any> {
    return this.api.get('user/avatar');
  }

  /**
   * Thực hiện đăng xuất
   */
  logout(): Observable<any> {
    return this.api.get('/logout');
  }

  /**
   * (Optional) Cập nhật avatar
   */
  updateAvatar(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.api.postFormData('user/updateAvatar', formData);
  }

  updateUser(payload: any): Observable<any> {
    return this.api.post('user/updateUser', payload);
  }
}
